import Me from "../img/me.png";
import Fb from "../img/icon-facebook.png";
import Insta from "../img/icon-instagram.png";
import Linkedin from "../img/icon-linkedin.png";
import GitHub from "../img/icon-github.png";

import { useSelector, useDispatch } from 'react-redux';

const SocialMap = [
  {
    img: Fb,
    alt: "logo-facebook",
    link: "https://www.facebook.com/GiraldaDesign/",
  },
  {
    img: Insta,
    alt: "logo-instagram",
    link: "https://www.instagram.com/giralda_design/",
  },
  {
    img: Linkedin,
    alt: "logo-linkedin",
    link: "https://www.linkedin.com/in/lorenzo-giralda-29026b19a/",
  },
  {
    img: GitHub,
    alt: "logo-GitHub",
    link: "https://github.com/LorenzoGiralda",
  }
];

const BoxMe = () => {

  const ValueView = useSelector((state) => state.ToggleLight.value)

  return (
    <div className="d-flex flex-column flex-lg-row align-items-center rounded justify-content-center p-2">
      <div className={`${ValueView ? 'bg-light' : 'bg-secondary'} shadow justify-content-center justify-content-lg-start rounded
      me-0 me-lg-3 mb-3 mb-lg-0 d-flex flex-column flex-lg-row flex-lg-nowrap align-items-center h-100`}>
        <div className="d-flex h-100 align-items-end">
          <img style={{'width': '1800px'}} className="img-fluid" src={Me} alt="Lorenzo Giralda - immagine del profilo"></img>
        </div>
        <section className="w-75 h-100 p-2 mt-3 mt-lg-0 d-flex flex-wrap flex-lg-nowrap flex-row flex-lg-column justify-content-center align-items-center h-100">
        { SocialMap.map( dato =>
          <a
            href={dato.link} target="_blank" rel="noreferrer" 
            className="mx-2 mx-lg-0 my-lg-3 p-2 my-1 rounded-circle d-flex justify-content-center align-items-center border border-dark"
            style={{ width: "40px", height: "40px" }}
          >
            <img className={dato.img === Fb ? 'w-50' : "img-fluid"} src={dato.img} alt=""></img>
          </a>
        )}
        </section>
      </div>
      <div className={`shadow rounded p-2 d-flex align-items-center h-100 ${ValueView ? 'bg-light' : 'bg-secondary text-white'}`}>
    <p style={{'text-align': "left"}} className={`m-0 p-0`}>
          {/* Piacere di conoscerti! Sono <strong>Lorenzo Giralda </strong> */}
          <h1 style={{fontSize: "1.0rem"}}>Sono <strong>Lorenzo</strong>, un creativo che si occupa di servizi di <strong>grafica, web, social e video</strong></h1>
        Da oltre 15 anni, sviluppo soluzioni coordinate e personalizzate che spaziano dalla <strong>grafica pubblicitaria</strong> e dalla stampa alla <strong>creazione di siti web</strong>, 
        <strong> gestione dei canali social</strong>, <strong>creazione e montaggio video</strong> e <strong>digital marketing</strong>. Aiuto aziende, professionisti e attività locali a valorizzare il proprio brand attraverso strategie su misura, capaci di generare risultati concreti sia online che offline.
        <br></br><br></br>
        Grazie a competenze trasversali nella <strong>comunicazione visiva e digitale,</strong> seguo ogni progetto a 360°.
        Offro una gamma completa di servizi professionali che include il <strong>graphic design</strong> per loghi e brand identity,
        il <strong>web design</strong> per siti moderni e ottimizzati SEO, la gestione di <strong>social media e video d'impatto</strong>,
        fino a strategie mirate di digital marketing per intercettare i tuoi clienti ideali.
         <br></br><br></br>
         La mia professionalità si è consolidata ricoprendo ruoli di rilievo. 
         Sono stato titolare di uno <strong>studio grafico Giralda Design a Roma</strong> e designer pubblicitario per importanti realtà aziendali come l'agenzia <strong>ICT Labs</strong> di Terni.
         Oggi metto questa esperienza a disposizione della <strong>Fondazione Emanuela Panetti</strong> come <strong>Communication Manager</strong>,
         continuando ad affiancare brand e attività come <strong>consulente freelance</strong>.
            <br></br><br></br>
         Il mio obiettivo? Diventare il tuo <strong>creativo di fiducia</strong> e il partner strategico per la crescita della tua attività.
      </p>
      </div>
    </div>
  );
};

export default BoxMe;